module.exports = __webpack_public_path__ + "img/2-4.285e742e.png";